import { useMsal } from "@azure/msal-react";
import type { ReactNode } from "react";
import React, { createContext, useEffect, useState } from "react";

import { getByPartitionKey, useGetTenantUser } from "../services/api-service";

const tenantTableName = "Tenant";
const tenantUserTableName = "TenantUser";

interface TenantContextType {
  tenant: { name: string; id: string; companyLicenses: number };
}

const defaultTenantValue = {
  name: "",
  id: "",
  companyLicenses: 0,
};

const TenantContext = createContext<TenantContextType>({
  tenant: defaultTenantValue,
});

interface TenantProviderProps {
  children: ReactNode;
}

export const TenantProvider: React.FC<TenantProviderProps> = ({ children }) => {
  const { accounts } = useMsal();
  const [tenant, setTenant] = useState<{
    name: string;
    id: string;
    companyLicenses: number;
  }>(defaultTenantValue);
  const account = accounts[0];
  const { data } = useGetTenantUser(
    tenantUserTableName,
    account?.username?.toLowerCase() ?? ""  
  );

  useEffect(() => {
    if (data !== undefined && data?.length > 0) {
      getByPartitionKey(tenantTableName, data[0].PartitionKey).then((t) => {
        setTenant({
          name: t[0]?.RowKey,
          id: t[0]?.PartitionKey,
          companyLicenses: t[0]?.CompanyLicenses,
        });
      });
    }
  }, [account?.username, data]);

  return (
    <TenantContext.Provider value={{ tenant }}>
      {children}
    </TenantContext.Provider>
  );
};

export default TenantContext;
